import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Cookies,
  getCookieConsentValue,
  resetCookieConsentValue,
} from 'react-cookie-consent';

import { COOKIE_BANNER } from '../constants';

const getCookieValue = (cookieName: string): string | null => {
  return getCookieConsentValue(cookieName);
};

export const useCookiePolicy = () => {
  const intId = useRef<NodeJS.Timeout | null>(null);

  const [withCookieBanner, setWithCookieBanner] = useState(
    !document.cookie.includes(COOKIE_BANNER),
  );

  const isCookiePolicyAccepted = useMemo(() => {
    const cookieValue = getCookieValue(COOKIE_BANNER);
    return cookieValue === 'true' || cookieValue === '1' || null;
  }, [withCookieBanner]);

  // Clear interval check if cookies are accepted
  useEffect(() => {
    clearInterval(intId.current);
  }, [withCookieBanner]);

  useEffect(() => {
    if (!withCookieBanner) {
      return;
    }

    // Check if banner is dismissed
    intId.current = setInterval(() => {
      const cookieAccepted = !document.cookie.includes(COOKIE_BANNER);
      if (cookieAccepted !== withCookieBanner) {
        setWithCookieBanner(cookieAccepted);
      }
    }, 100);

    return () => {
      // Clear interval when component is removed
      clearInterval(intId.current);
    };
  }, []);

  const resetCookiePolicy = () => {
    resetCookieConsentValue(COOKIE_BANNER);
    setWithCookieBanner(true);
    window.location.reload();
  };

  return {
    isCookieBanner: withCookieBanner,
    isCookiePolicyAccepted,
    resetCookiePolicy,
  };
};
